import Axios from "axios";

export const getLocation = async (setCountryCode, setLoader) => {
  setLoader(true);
  let getIPaddress = await Axios.get("https://api64.ipify.org/");
  let currentLocationInfo = await Axios.get(
    `https://api.ipapi.com/${getIPaddress.data}?access_key=8a6e6544ec0ff1478e9cf54138dfb1ed`
  );

  setCountryCode(currentLocationInfo.data.country_code);
  setLoader(false);
  return await currentLocationInfo.data;
};

export const getIpLocation = async () => {
  let getIPaddress = await Axios.get("https://api64.ipify.org/");
  return getIPaddress ? getIPaddress.data : null;
};

export const getOnlyLocationDetail = async () =>{
  try{
    const ip = await getIpLocation()
    if(!ip) return false
    let currentLocationInfo = await Axios.get(
      `https://api.ipapi.com/${ip}?access_key=8a6e6544ec0ff1478e9cf54138dfb1ed`
    );
    return currentLocationInfo ? currentLocationInfo?.data : false;
  }
  catch(e){
    return false
  }

}
